import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { ReactComponent as AddStyle } from '../../assets/svg/addStyle.svg';
import { ReactComponent as AddStyleBtn } from '../../assets/svg/hangerPlus.svg';
import { ReactComponent as CloseBtn } from '../../assets/svg/close.svg';
import { ReactComponent as AddItemBtn } from '../../assets/svg/items.svg';
import { NavLink } from 'react-router-dom';
import { PATH } from '../../routes/constant';

const transition =
    '.3s transform cubic-bezier(0.22,-0.57, 0.51, 1.07), .2s .1s opacity, .15s background-color ease-in-out, .3s box-shadow';
const position = 'absolute';
const buttonStyles = makeStyles({
    btnWrapper: {
        position: 'relative',
    },
    mainBtn: {
        transition,
        position,
        zIndex: 10,
        transform: 'translate(-50%, -50%)',
        '&Disable': {
            opacity: 0,
        },
    },
    mainFlipBtn: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 36,
        height: 36,
        position,
        transform: 'translate(-50%, -50%)',
        transition,
        zIndex: 9,
        opacity: 0,
        '&Active': {
            opacity: 1,
            zIndex: 11,
        },
    },
    floatBtn: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 48,
        height: 48,
        backgroundColor: '#FFFFFF',
        borderRadius: '50%',
        opacity: 0,
        position,
        top: -24,
        left: -24,
        transition,
        zIndex: 9,
        '&Active': {
            opacity: 1,
            zIndex: 11,
            '&-1': {
                transform: 'translate(-30px, -68px)',
            },
            '&-2': {
                transform: 'translate(30px, -68px)',
            },
            transition:
                '0.2s 0.015s transform cubic-bezier(0.33, 0.16, 0.26, 1.72), .1s opacity, .15s background-color ease-in-out, .3s box-shadow',
        },
    },
});

const CreateStyleItemButton = (props) => {
    const styles = buttonStyles();
    const [showFloatBtn, setShowFloatBtn] = useState(false);

    const handleClick = (e) => {
        if (props.isDisable) e.preventDefault();
    };

    return (
        <div className={styles.btnWrapper}>
            <div
                className={`${styles.mainBtn} ${showFloatBtn ? styles.mainBtn + 'Disable' : ''}`}
                onClick={() => setShowFloatBtn(true)}
            >
                <AddStyle />
            </div>
            <div
                className={`${styles.mainFlipBtn} ${showFloatBtn ? styles.mainFlipBtn + 'Active' : ''}`}
                onClick={() => setShowFloatBtn(false)}
            >
                <CloseBtn />
            </div>
            <div
                className={`${styles.floatBtn} ${
                    showFloatBtn ? `${styles.floatBtn}Active ${styles.floatBtn}Active-1` : ''
                }`}
            >
                <NavLink to={PATH.CREATE_STYLE_CANVAS} onClick={handleClick}>
                    <AddStyleBtn />
                </NavLink>
            </div>
            <div
                className={`${styles.floatBtn} ${
                    showFloatBtn ? `${styles.floatBtn}Active ${styles.floatBtn}Active-2` : ''
                }`}
            >
                <NavLink to={PATH.CREATE_ITEM} onClick={handleClick}>
                    <AddItemBtn />
                </NavLink>
            </div>
        </div>
    );
};

export default CreateStyleItemButton;
